import React from 'react';
import ReactDOM from 'react-dom/client';

import "./assets/scss/themes.scss";
import "./index.css";

import reportWebVitals from './reportWebVitals';

import {
    BrowserRouter,
    Routes,
    Route,
} from "react-router-dom";

import { CommerceProvider } from './commerce/CommerceContext';

// Pages
import LoopCoffee from './pages/loop-coffee';
import Checkout from './pages/checkout';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <CommerceProvider>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<LoopCoffee />} />
                <Route path="/home" element={<LoopCoffee />} />
                <Route path="/checkout" element={<Checkout />} />
            </Routes>
        </BrowserRouter>
    </CommerceProvider>
);

// Performance monitoring
reportWebVitals();
